module.exports = __webpack_public_path__ + "img/rec-05.442f02ed.png";